export default __webpack_public_path__ + "static/media/background.4e95c476.jpg";